import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-smoke-gradient border-b border-amber/10" data-id="element-76">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-77">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-79">
            <div className="inline-block mb-4 px-3 py-1 border border-amber/30 bg-amber/10 text-amber-light font-semibold text-sm tracking-wider rounded-full uppercase" data-id="element-80">
              Para hombres 45+
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-white drop-shadow-lg" data-id="element-81">
              PARRILLADA SIN DOLOR: <br data-id="element-82" />
              <span className="text-transparent bg-clip-text bg-fire-gradient" data-id="element-83">
                EL MÉTODO DEL ASADO ANTIINFLAMATORIO
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-offwhite/90 mb-10 font-medium leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-84">
              Vuelve a disfrutar del fuego este domingo y despierta el lunes sin
              rigidez, sin gota y sin dolor articular.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-85">
              <Button className="w-full sm:w-auto" data-id="element-86">
                ¡Quiero mi guía parrillada sin dolor!
              </Button>
            </div>
            <p className="mt-4 text-sm text-offwhite/60 flex items-center justify-center lg:justify-start gap-2" data-id="element-87">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-88"></span>
              Acceso instantáneo • Pago 100% seguro
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-89">
            <div className="absolute -inset-4 bg-amber/20 blur-3xl rounded-full opacity-50" data-id="element-90"></div>
            <img src="https://cdn.magicpatterns.com/uploads/q8ere6urmHMtyRtRGSJbxY/heylloyd-image-1774703205617.png" alt="Parrillada Sin Dolor - Guía Digital" className="relative z-10 w-full rounded-xl shadow-2xl border border-white/10" data-id="element-91" />
          </motion.div>
        </div>
      </div>
    </section>;
}